import { makeAutoObservable } from 'mobx';
import IShortTicket, { IShortTask } from '../../models/ticket';
import FilesService from "../../services/files-service";
import { TicketService } from '../../services/ticket-service';
import Subjects from '../../models/subjects';
import { message } from 'antd';

export default class TicketItemStore {

    data: IShortTicket;

    expanded: boolean;

    filesService: FilesService;

    ticketService: TicketService;

    subject: Subjects;

    selectedStudents: number[];

    constructor(data: IShortTicket, subject: Subjects) {

        this.data = data;
        this.expanded = false;
        this.filesService = new FilesService();
        this.ticketService = new TicketService(subject);
        this.subject = subject;
        this.selectedStudents = [];
        makeAutoObservable(this);
    }

    toggle() {
        this.expanded = !this.expanded;
    }

    getUrl(fileId: string): string {
        return this.filesService.getFileUrl(fileId);
    }

    enumerateTasks(): IShortTask[] {
        return this.data.tasks.map((item, index) => { return { index, ...item } });
    }

    rollback() {
        this.ticketService.rollback(this.data.id, () => { window.location.replace(`/${this.subject}/tickets/add`); });
    }

    selectStudents(value: number[]): void {
        this.selectedStudents = value;
    }

    assignStudents() {

        if (this.selectedStudents) {
            this.ticketService.assignStudents(
                this.data.id, this.selectedStudents,
                (_) => {
                    this.selectedStudents = [];
                    message.success("Вариант успешно добавлен ученикам");
                });
        } else {
            message.error("Не выбраны ученики");
        }
    }

    createClone() {
        
        this.ticketService.createClone(
            this.data.id,
            (data) => {
                window.location.replace(`/${this.subject.toLowerCase()}/tickets/add`);
            }
        )
    }
}